var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8349_25367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16H16V6L10 0H0V16Z",
    fill: "url(#paint0_linear_8349_25367)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_8349_25367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76018 13.88C5.44551 13.88 5.17351 13.8267 4.94418 13.72C4.72018 13.6187 4.54951 13.4667 4.43218 13.264C4.31484 13.0667 4.26418 12.8293 4.28018 12.552L4.36018 11.24C4.37084 11.0427 4.35484 10.888 4.31218 10.776C4.27484 10.6587 4.19751 10.5733 4.08018 10.52C3.96284 10.4667 3.78951 10.44 3.56018 10.44H2.68018V9.79999H3.56018C3.78951 9.79999 3.96284 9.77332 4.08018 9.71999C4.19751 9.66665 4.27484 9.58399 4.31218 9.47199C4.35484 9.35999 4.37084 9.20265 4.36018 8.99999L4.28018 7.68799C4.26418 7.41065 4.31484 7.17332 4.43218 6.97599C4.54951 6.77332 4.72018 6.62132 4.94418 6.51999C5.17351 6.41332 5.44551 6.35999 5.76018 6.35999H6.12018V6.99999H5.76018C5.50418 6.99999 5.30951 7.05865 5.17618 7.17599C5.04818 7.29332 4.98951 7.46399 5.00018 7.68799L5.08018 8.99999C5.10151 9.34665 5.01884 9.62399 4.83218 9.83199C4.64551 10.0347 4.38151 10.136 4.04018 10.136V10.096C4.37618 10.096 4.63751 10.2 4.82418 10.408C5.01618 10.616 5.10151 10.8933 5.08018 11.24L5.00018 12.552C4.98951 12.776 5.04818 12.9467 5.17618 13.064C5.30951 13.1813 5.50418 13.24 5.76018 13.24H6.12018V13.88H5.76018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47705 13.88V13.24H7.83705C8.09305 13.24 8.28505 13.1813 8.41305 13.064C8.54638 12.9467 8.60772 12.776 8.59705 12.552L8.51705 11.24C8.49572 10.8933 8.57838 10.616 8.76505 10.408C8.95705 10.2 9.22105 10.096 9.55705 10.096V10.136C9.21572 10.136 8.95172 10.0347 8.76505 9.83199C8.57838 9.62399 8.49572 9.34665 8.51705 8.99999L8.59705 7.68799C8.60772 7.46399 8.54638 7.29332 8.41305 7.17599C8.28505 7.05865 8.09305 6.99999 7.83705 6.99999H7.47705V6.35999H7.83705C8.15172 6.35999 8.42105 6.41332 8.64505 6.51999C8.87438 6.62132 9.04772 6.77332 9.16505 6.97599C9.28238 7.17332 9.33305 7.41065 9.31705 7.68799L9.23705 8.99999C9.22638 9.20265 9.23972 9.35999 9.27705 9.47199C9.31972 9.58399 9.39972 9.66665 9.51705 9.71999C9.63438 9.77332 9.80772 9.79999 10.0371 9.79999H10.9171V10.44H10.0371C9.80772 10.44 9.63438 10.4667 9.51705 10.52C9.39972 10.5733 9.31972 10.6587 9.27705 10.776C9.23972 10.888 9.22638 11.0427 9.23705 11.24L9.31705 12.552C9.33305 12.8293 9.28238 13.0667 9.16505 13.264C9.04772 13.4667 8.87438 13.6187 8.64505 13.72C8.42105 13.8267 8.15172 13.88 7.83705 13.88H7.47705Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8349_25367",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8349_25367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8349_25367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8349_25367",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CD297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50AFA2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8349_25367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.756bdbdaf341c641465605bcac5820c5.svg";
export { ForwardRef as ReactComponent };